import React, { useEffect, useState } from 'react';
import { _t } from "../i18n";

function GoogleTranslate() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);

  // Define googleTranslateElementInit in a way it will be available globally
  const initTranslation = () => {
    if (!window.google || !window.google.translate) {
      console.warn('Google Translate not available yet');
      return;
    }

    const element = document.getElementById("google_translate_element");
    if (!element) {
      console.warn('Translation element not found');
      return;
    }

    try {
      if (element.children.length === 0) {
        console.log('Initializing Google Translate');
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "fr",
            includedLanguages: "en,es,de,it",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false
          },
          "google_translate_element"
        );
        setIsLoaded(true);
      }
    } catch (error) {
      console.error('Error initializing Google Translate:', error);
      setIsError(true);
    }
  };

  useEffect(() => {
    // Set global init function
    window.googleTranslateElementInit = initTranslation;

    // If script already exists, just initialize translator
    if (document.querySelector('script[src*="translate_a/element.js"]')) {
      console.log('Google Translate script already exists, initializing');

      if (window.google && window.google.translate) {
        console.log('Google Translate already loaded, initializing');
        initTranslation();
      }

      setIsLoaded(true);
      return;
    }

    // Otherwise, create and add the script
    console.log('Adding Google Translate script');
    const script = document.createElement('script');
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.defer = true;

    script.onerror = () => {
      console.error('Failed to load Google Translate script');
      setIsError(true);
    };

    document.body.appendChild(script);

    // Add custom CSS for the Google Translate element
    const style = document.createElement('style');
    style.textContent = `
      #google_translate_element .goog-te-gadget-simple {
        border: none !important;
        background: transparent !important;
        padding: 0 !important;
      }
      #google_translate_element .goog-te-gadget {
        color: transparent !important;
      }
      #google_translate_element .goog-te-combo {
        height: 28px !important;
        color: #555 !important;
        padding: 4px !important;
        border-radius: 4px !important;
        border: 1px solid #ddd !important;
        background-color: white !important;
        max-width: 150px !important;
        min-width: 100px !important;
      }
      #google_translate_element img,
      #google_translate_element a.goog-logo-link {
        display: none !important;
      }
      .dark #google_translate_element .goog-te-combo {
        background-color: #374151 !important;
        border-color: #4B5563 !important;
        color: #E5E7EB !important;
      }
    `;
    document.head.appendChild(style);

    // Try to initiate translation a few times to ensure it works
    const checkInterval = setInterval(() => {
      if (window.google && window.google.translate && !isLoaded) {
        initTranslation();
      }
    }, 1000);

    // Cleanup
    return () => {
      clearInterval(checkInterval);
    };
  }, [isLoaded]);

  return (
    <div className="translate-widget">
      {isError && (
        <div className="text-xs text-red-500">
          {_t('Translation unavailable')}
        </div>
      )}
      <div
        id="google_translate_element"
        className="w-full"
        aria-label="Google Translate Widget"
      >
        {!isLoaded && !isError && (
          <div className="text-xs text-gray-500 animate-pulse">
            {_t('Loading translator...')}
          </div>
        )}
      </div>
    </div>
  );
}

export default GoogleTranslate;